var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-progress-spinner',{staticClass:"md-cyan-900",attrs:{"md-diameter":_vm.width,"md-stroke":_vm.height,"md-mode":"indeterminate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }